import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { formatComposer, formatLetterViewerRoute } from '../../data/routes';

const useOpenLetter = (id: string, { isDraft } = { isDraft: false }) => {
  const navigate = useNavigate();

  return useCallback(() => {
    if (isDraft) {
      navigate(formatComposer({ letterId: id }));
    } else {
      navigate(formatLetterViewerRoute({ letterId: id }));
    }
  }, [id, navigate, isDraft]);
};

export default useOpenLetter;
